import { apiSlice } from '../../../api/common/apiSlice';
import { ApiTagType } from '../../../constants/apiTagType';
import { FetchUserIndexFundsFxResponse } from '../../../types/userIndexFund';

export const userIndexFundsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchUserIndexFunds: builder.query<FetchUserIndexFundsFxResponse, number>({
      query: (userId) => ({
        url: `/admin/user-index-fund/user/${userId}`,
        method: 'GET',
      }),
      providesTags: (res) => {
        if (res) {
          return [
            ...(res.items || []).map(({ id }) => ({ type: ApiTagType.UserIndexFund as const, id })),
            { type: ApiTagType.UserIndexFund, id: 'LIST' },
          ];
        }
        return [{ type: ApiTagType.UserIndexFund, id: 'LIST' }];
      },
    }),
  }),
});

export const { useFetchUserIndexFundsQuery } = userIndexFundsApiSlice;
